import { Link } from 'react-router-dom';
import './LandingPage.css';
import { SCREENS } from '../lib/screenRegistry';

const INTRO_COPY =
  'Mentology Framework is not just an application, it is a rigorous science of strategic growth delivered through a high-performance AI Mentor. The Mentology AI App moves beyond informal \u201Cbuddy systems\u201D to provide a predictive engine for your personal and business evolution. It is the first platform to translate complex sociopsychological frameworks into real-time, actionable insights.';

export default function LandingPage() {
  return (
    <div className="landing-page" data-screen-id={SCREENS.ELT01}>
      <div className="landing-logo-wrap">
        <img
          src={encodeURI('/Assets/logo/Mentology Logo.png')}
          alt="Mentology"
          className="landing-logo brand-logo"
          onError={(e) => {
            (e.target as HTMLImageElement).style.display = 'none';
          }}
        />
      </div>
      <div className="landing-content">
        <p className="landing-intro">{INTRO_COPY}</p>
        <div className="landing-button-box">
          <div className="button-control-group">
            <Link to="/portal-login" className="btn-landing-primary">
              Mentoring Portal
            </Link>
            <Link to="/register-select" className="btn-landing-primary">
              New Registration
            </Link>
          </div>
        </div>

        <div className="landing-divider" aria-hidden="true" />

        <p className="landing-stress-test-copy">
          If in doubt, why not experience the Mentology Socratic inquiry? Pressure-tests your
          business logic and uncover potential operational blind spots before you commit capital.
        </p>
        <div className="landing-stress-test-cta">
          <Link to="/stress-test" className="btn-landing-stress-test">
            Start Free 10-Minute Business Strategy Stress-Test
          </Link>
        </div>
      </div>
    </div>
  );
}
